//src\app\app.component.ts
import {
    Component,
    OnInit,
    Input,
    Output,
    ViewEncapsulation,
    EventEmitter,
    ViewContainerRef,
    ViewChild,
    ComponentFactoryResolver,
    ComponentRef,
    OnDestroy,
    TemplateRef
  } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../confirm/confirm.component';
import { Documento } from '../models/documento.model';
import { Forma } from '../models/formulario-dinamico.model';
import { Tarea } from '../models/tarea.model';
import { ScannerService } from "./shared/scanner.service";

@Component({
  selector: "iw-scanner",
  templateUrl: "./scanner.component.html",
  styleUrls: ["./scanner.component.scss"],
  providers: [ScannerService]
})

export class ScannerComponent implements OnInit, OnDestroy{
   // Tarea actual
    @Input() task?: Tarea;
    // // Forma de la tarea
    // @Input() form: Forma;
    @Input() document: Documento;
    // salida del documento escaneado
    @Output() documentResult = new EventEmitter<Blob>();

    title:any = 'socketrv';
    content:any = '1100';
    received:any = [];
    sent:any = [];
    // Referencia al template de la modal de visulizacion de documento
    @ViewChild('templatePreviewDocScanned') private templatePreviewDocScanned: TemplateRef<any>;
    // Componente de confirmaciones
    @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;
    modalRef: any;
    private searchEventSubscription: Subscription;

  constructor(private scannerService: ScannerService,
     private modalService: BsModalService,) {
    
  }
    ngOnInit(): void {
      this.searchEventSubscription = this.scannerService.messages.subscribe(msg => {
        var file = new Blob([msg], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        this.modalRef = this.modalService.show(this.templatePreviewDocScanned, { class: 'modal-dialog-centered modal-lg'});
        let type = "pdf";
        let documentModal = {"tipo": type, "ruta": fileURL, "blob_file": file} 
        this.modalRef.content = documentModal;
      });
    }
    ngOnDestroy(): void {
      this.searchEventSubscription.unsubscribe();
    }
  sendMsg() {
    let message = {
      source: '',
      content: '1100'
    };
    message.source = 'localhost';
    message.content = this.content;

    this.sent.push(message);
    this.scannerService.messages.next("1100");
  }

     /**
   * cierra el modal con el la previsualizacion de documento
   *
   * @memberof ScannerComponent
   */
      closeModalPreviewDoc() {
        this.confirmRef.new({
            question: '¿Desea guardar el archivo escaneado?',
            labelConfirm: 'Sí',
            labelDecline: 'No'
          }).then(resp => {
            if (resp) {
              let dataD = {
                'clasificacion_documento_id': this.document.clasificacion_id,
                'file_name': this.document.clasificacion,
                'id_tarea': this.document.idtarea,
                'file': this.modalRef.content['blob_file'],
                'documento_escaneado': true
              };
              this.documentResult.emit(this.modalRef.content['blob_file']);
              this.modalRef.hide();
            }
            else{
              this.documentResult.emit(null);
              this.modalRef.hide();
            }
          });
      }
}


// WEBPACK FOOTER //
// ./src/app/shared/scanner/scanner.component.ts